import { render, staticRenderFns } from "./BeaconListMixin.vue?vue&type=template&id=5fd8e51d&"
import script from "./BeaconListMixin.vue?vue&type=script&lang=ts&"
export * from "./BeaconListMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports